import { useNavigate } from "react-router-dom";
import { useUserContext } from "./userContext";

// Sai do app: apaga o token salvo, limpa o usuário e volta para o login
export const useLogout = () => {
  const { dispatch } = useUserContext();
  const navigate = useNavigate();

  return () => {
    localStorage.removeItem("token");
    dispatch({ type: "CLEAR_USER" });
    navigate("/", { replace: true });
  };
};
